import React from 'react';
import {Popover, Transition} from '@headlessui/react';
import {Certificate, GenerateCertificateState, Maybe} from '../schema';

import IconCertificate from '../components/icon/IconCertificate';
import cn from 'classnames';
import CertificateAvailability from '../models/event/CertificateAvailability';

type Props = {
  state: GenerateCertificateState
  canGenerate: boolean
  certificate?: Maybe<Certificate>
  onGenerateClick?: () => void
  className?: string
}

export default function AttendeeCertificateStatus({state, canGenerate, certificate, onGenerateClick, className}: Props) {

  if (certificate && certificate.id) {
    return (
      <div className={className}>
        <IconCertificate className="text-gray-dark mr-1"/>
        {!certificate.generating &&
          <>
            Certificate < a className="text-blue" target="_blank"
                            rel="noreferrer" href={certificate.url}>{certificate.id}</a>
          </>
        }
        {certificate.generating && <>Generating certificate...</>}
      </div>
    );
  }

  if (state === GenerateCertificateState.OK && canGenerate) {
    return (<button onClick={onGenerateClick} className={cn("text-blue", className)}>
      <IconCertificate className="text-gray-dark"/> Generate certificate</button>);
  }

  const status = CertificateAvailability.isPotentiallyAvailable(state)
    ? 'Generation not possible'
    : 'Certificate not available';

  return (
    <Popover className="relative">
      <Popover.Button>
        <div className={cn(className, 'border-dotted border-b')}>
          <IconCertificate className="text-gray-dark"/> {status}
        </div>
      </Popover.Button>

      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Popover.Panel className="absolute z-10 p-3 mt-2 bg-white rounded border border-gray shadow-lg">
          <div className="text-sm">
            {state === GenerateCertificateState.FAIL_EVENT_NO_CERTIFICATE && (
              <>There is no certificate template suitable for this event. Generation of certificate is not possible.</>
            )}
            {state === GenerateCertificateState.FAIL_EVENT_NOT_CONFIRMED && (
              <>Confirm the event to make certificate available for generation</>
            )}
            {state === GenerateCertificateState.FAIL_EVENT_NOT_STARTED && (
              <>You will be able to generate certificate as soon as the event starts</>
            )}
            {state === GenerateCertificateState.FAIL_NO_EVALUATION && (
              <>To get a certificate, the attendee should provide an evaluation</>
            )}
            {state === GenerateCertificateState.FAIL_NOT_PARTICIPATED && (
              <>Change the status of attendee to `Participated` to generate a certificate</>
            )}
            {state === GenerateCertificateState.NOT_EXPECTED && (
              <span className="text-red">There is an error. Please contact a support team.</span>
            )}
            {state === GenerateCertificateState.OK && !canGenerate && (
              <>You do not have permission to generate a certificate</>
            )}
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>

  );
}
